import { UseAxiosResult } from 'axios-hooks'
import { useAxiosClient } from './configs/axios-setup'

export const useGetUtilizationSummary = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ series, month, year }: any) => {
    return doFetch({
      url: `/Reports/${series}/utilization-summary?month=${month}&year=${year}&series=${series}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetReport = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ org, series, page, pageSize, month, year }: any) => {
    return doFetch({
      url: `/Reports/${series}?page=${page}&pageSize=${pageSize}&month=${month}&year=${year}&org=${org}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetReportCount = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ org, series, month, year }: any) => {
    return doFetch({
      url: `/Reports/${series}/count?month=${month}&year=${year}&org=${org}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetReportFile = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ org, series, month, year }: any) => {
    return doFetch({
      url: `/Reports/${series}/download?month=${month}&year=${year}&org=${org}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetHeadlineData = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ page, pageSize, projects }: any) => {
    return doFetch({
      url: `/HeadlineData/headline-data?page=${page}&pageSize=${pageSize}&projects=${projects}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetGroupForceData = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ caseId }: any) => {
    return doFetch({
      url: `/HeadlineData/group-force-data?caseId=${caseId || ''}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetHeadlineDraftingInfo = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ cases }: any) => {
    return doFetch({
      url: `/HeadlineData/drafting-info?cases=${encodeURIComponent(cases)}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetHeadlineDataByCases = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ page, pageSize, cases }: any) => {
    return doFetch({
      url: `/HeadlineData/headline-data-by-cases?page=${page}&pageSize=${pageSize}&cases=${cases}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetHeadlineDataProjectRun = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ userId, page, pageSize, car, area }: any) => {
    let queryParam = ''
    if (userId) queryParam += `userId=${encodeURIComponent(userId)}`
    if (page !== undefined) queryParam += `${queryParam ? '&' : ''}page=${page}`
    if (pageSize !== undefined) queryParam += `${queryParam ? '&' : ''}pageSize=${pageSize}`
    if (car) queryParam += `${queryParam ? '&' : ''}car=${encodeURIComponent(car)}`
    if (area) queryParam += `${queryParam ? '&' : ''}area=${encodeURIComponent(area)}`
    return doFetch({
      url: `/HeadlineData/headline-data-project-run?${queryParam}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetRunsOverview = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ userId }: any = {}) => {
    const qp = userId ? `?userId=${encodeURIComponent(userId)}` : ''
    return doFetch({ url: `/HeadlineData/runs-overview${qp}` })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetHeadlineDataLatestProject = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ limit }: any) => {
    return doFetch({
      url: `/HeadlineData/headline-data-latest-project?limit=${limit}`
    })
  }
  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetHeadlineDataByCase = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = (caseNumber: any) => {
    return doFetch({
      url: `/HeadlineData/run-case-data?caseNumber=${caseNumber}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetRunCase = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = (caseNumber: any) => {
    return doFetch({
      url: `/HeadlineData/cases/${caseNumber || ''}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetHeadlineBaselineRuns = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = () => {
    return doFetch({
      url: `/HeadlineData/baseline-runs`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetMonitors = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ cases }: any) => {
    return doFetch({
      url: `/HeadlineData/monitors?cases=${cases}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetMonitorsProjectRunCase = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ userId }: any) => {
    return doFetch({
      url: `/HeadlineData/monitors-project-run-case?userId=${userId}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetMonitorData = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ xAxis, yAxis, cases }: any) => {
    return doFetch({
      url: `/HeadlineData/monitors-data?xAxis=${xAxis}&yAxis=${yAxis}&cases=${cases}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetCoefficientBox = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ cd, cl }: any) => {
    return doFetch({
      url: `/HeadlineData/coefficient-box?cd=${cd}&cl=${cl}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetCup28ProjectRun = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = () => {
    return doFetch({
      url: `/HeadlineData/cup-28-project-run`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetCupProjectRunCoefficientData = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ project, run }: any) => {
    return doFetch({
      url: `/HeadlineData/cup-coefficient-data?project=${encodeURIComponent(
        project || ''
      )}&run=${encodeURIComponent(run || '')}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useRecalculateCupRunCoefficientData = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'POST'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ run, exclusion }: any) => {
    return doFetch({
      url: `/HeadlineData/cup-coefficient-data`,
      data: { run, exclusion }
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}

export const useGetCupRunCoefficientRecalculateStatus = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      method: 'GET'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  const refetch = ({ runId }: any) => {
    return doFetch({
      url: `/HeadlineData/coefficient-recalculation-status?runId=${encodeURIComponent(runId)}`
    })
  }

  return [
    { data, loading, error },
    refetch,
    () => {
      return
    }
  ]
}
